import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsAgentStudioConversationReviewRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-agent-studio-conversation-review',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/review/:conversationId?',
	exact: true,
};
